module.exports = __webpack_public_path__ + "img/img_level_6.a65152f7.png";